const { GdprStorage } = await import("uidispatcher_api/UidispatcherApiModule");
export default GdprStorage;
